import { RootState } from '../index';
export const getOnboarding = (state: RootState) => {
  return state.onboarding;
};
